import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';

export function useSetCurrentRoute() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (routeId: string) => apiClient.post(`/routes/${routeId}/set-current`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.routes.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.routes.current });
      void queryClient.invalidateQueries({ queryKey: queryKeys.vesselMapState });
    },
  });
}
